import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=ed5adf50&"
import script from "./AllUsers.vue?vue&type=script&lang=ts&"
export * from "./AllUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports